module.exports = __webpack_public_path__ + "img/468.3a7128b2.png";